import { SegmentedToggle } from '@hakimo-ui/shared/ui-base';
import { ReactNode } from 'react';
import { RESPONDER_OPTIONS, type ResponderType } from '../util';
import { LABEL } from './util';

interface ResponderToggleProps {
  badge: ReactNode;
  value: ResponderType;
  onChange: (value: ResponderType) => void;
}

export function ResponderToggle({
  badge,
  value,
  onChange,
}: ResponderToggleProps) {
  return (
    <div className="flex flex-wrap items-center gap-2.5">
      {badge}
      <span className={LABEL}>Responder</span>
      <SegmentedToggle
        value={value}
        options={RESPONDER_OPTIONS.map((o) => ({
          id: o.value,
          label: o.label,
        }))}
        variant="pill"
        onChange={(v) => onChange(v as ResponderType)}
      />
    </div>
  );
}
